import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "u", "s", "sub", "sup", "span", "code", "pre",
  "h1", "h2", "h3", "h4", "h5", "blockquote",
  "ul", "ol", "li", "a", "img",
  "table", "thead", "tbody", "tr", "th", "td",
  "hr", "div", "video", "source",
];

const safeImage = /^data:image\/(?:png|jpe?g|gif|webp);base64,/i;

DOMPurify.addHook("uponSanitizeAttribute", (_node, data) => {
  if (data.attrName === "src" && data.attrValue.startsWith("data:") && !safeImage.test(data.attrValue)) {
    data.keepAttr = false;
  }
});

/** Browser-side defense for stored wangEditor HTML. The server allowlist remains authoritative. */
export function sanitizeRichHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "rel", "target", "src", "alt", "width", "height", "colspan", "rowspan", "class", "style", "controls", "poster", "type"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|data:image\/(?:png|jpe?g|gif|webp);base64,)/i,
  });
}
